module.exports = __webpack_public_path__ + "img/ic_gift_sel.14ab998d.svg";